import { useEffect, useState, useRef } from "react";
import { LottieRefCurrentProps } from "lottie-react";

export const useLottieProgress = (
  lottieRef: React.RefObject<LottieRefCurrentProps>,
  inView: boolean,
  isPlaying: boolean
) => {
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!inView || !isPlaying) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Use setInterval for more predictable updates
    intervalRef.current = setInterval(() => {
      if (lottieRef.current?.animationItem) {
        const currentFrame = lottieRef.current.animationItem.currentFrame;
        const totalFrames = lottieRef.current.animationItem.totalFrames;
        const newProgress = (currentFrame / totalFrames) * 100;
        setProgress(newProgress);
      }
    }, 16); // ~60fps

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [inView, isPlaying, lottieRef]);

  return progress;
};
